"use client";

import React from "react";
import { cn } from "utils";

interface CardSkeletonProps {
  className?: string;
}

export const CardSkeleton: React.FC<CardSkeletonProps> = ({ className }) => {
  return (
    <div className={cn("flex flex-col gap-4 w-full", className)}>
      <div className="inline-flex flex-col gap-4">
        <div className="inline-flex items-center gap-2">
          <div className="w-[56px] h-[56px] rounded-full bg-background_white_overlay5 animate-pulse" />

          <div className="inline-flex flex-col gap-[9px] justify-center">
            <div className="bg-background_white_overlay5 rounded h-5 w-16 animate-pulse" />
            <div className="bg-background_white_overlay5 rounded h-5 w-[138px] animate-pulse" />
          </div>
        </div>

        <div className="bg-background_white_overlay5 rounded flex items-center justify-center gap-2.5 h-[38px] w-[198px] animate-pulse" />
      </div>
    </div>
  );
};
